export default __webpack_public_path__ + "static/media/size_jar_selected.27d983f4.svg";